import { render, staticRenderFns } from "./DialogHistory.vue?vue&type=template&id=804fb774&scoped=true"
import script from "./DialogHistory.vue?vue&type=script&lang=js"
export * from "./DialogHistory.vue?vue&type=script&lang=js"
import style0 from "./DialogHistory.vue?vue&type=style&index=0&id=804fb774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804fb774",
  null
  
)

export default component.exports